<nav class="bottom-mobile-bar app-header d-lg-none" [ngClass]="{'dimmed-header' : IsDimmed}">
  <div class="container">
    <ul class="nav-wrp header-wrapper">
      <li class="nav-item">
        <a aria-label="mobile-logo" title="{{'common.portalName' | translate}}" routerLink="/" class="mobile-logo"
          tooltip="{{'common.portalName' | translate}}" (click)="closeModal()">
          <img loading="lazy" width="148" height="62" src="../../assets/images/logo.webp"
            alt="{{'common.portalName' | translate}}" />
        </a>
      </li>
      <ul class="nav-wrp">

        <li class="nav-item " dropdown [insideClick]="true">
          <button aria-label="uppercase" type="button" class=" mobile-header-btn" (click)="onLanguageSwitched($event)"
            tooltip="{{'languageSwitcher.header' | translate}}" placement="right">
            <span class="switch-lan">{{switchToLang | uppercase}}</span>
          </button>
        </li>
        <li class="nav-item" dropdown [insideClick]="true">
          <button #offcanvasButtontheme type="button" aria-label="offcanvas Theme" class=" mobile-header-btn"
            data-bs-toggle="offcanvas" data-bs-target="#offcanvasTheme" aria-controls="offcanvasTop"
            tooltip="{{'header.settings' | translate}}" placement="right" (click)="closeModal()">
            <i class="icon icon-fi-rr-opacity setting-icon"></i>
          </button>
        </li>
        <div #offcanvasDivTheme class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasTheme"
          aria-labelledby="offcanvasTopLabel">
          <div class="offcanvas-header">
            <h5 class="head-offcanvas" id="offcanvasTopLabel">{{'header.settings' | translate}}</h5>
            <button #closeButtonTheme aria-label="Clear Filter" type="button" class="btn-close text-reset"
              data-bs-dismiss="offcanvas" aria-label="Close" (click)="offcanvasClearFilter()"></button>
          </div>
          <div class="offcanvas-body">
            <app-theme-switcher></app-theme-switcher>
          </div>
        </div>
        <li class="nav-item" dropdown [insideClick]="true">
          <button #offcanvasButtonSetting type="button" aria-label="offcanva Setings" data-bs-toggle="offcanvas"
            data-bs-target="#offcanvaSetings" aria-controls="offcanvasTop" tooltip="{{'header.Menu' | translate}}"
            placement="right" (click)="closeModal()">
            <i class="icon-fi-rr-menu-burger nav-item"></i>
          </button>
        </li>
        <div #offcanvasDivSetting class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvaSetings"
          aria-labelledby="offcanvasTopLabel">
          <div class="offcanvas-header">
            <h5 class="head-offcanvas" id="offcanvasTopLabel">{{'header.Menu' | translate}}</h5>
            <button #closeButtonSetting type="button" aria-label="offcanvasClearFilter" class="btn-close text-reset"
              data-bs-dismiss="offcanvas" aria-label="Close" (click)="offcanvasClearFilter()"></button>
          </div>
          <div class="offcanvas-body">
            <ul class="mobile-settings-offCanvas">
              <li *ngIf="currentUserName">
                <a aria-label="account" routerLink="/account/profile-menu" title="{{'header.account' | translate}}"
                  class="title">
                  <span class="icon icon-user-full full"></span>
                  {{'header.account' | translate}}
                </a>
              </li>
              <li *ngIf="currentUserName">
                <a aria-label="notifications" routerLink="/notifications" title="{{'header.notifications' | translate}}"
                  class="title">
                  <span class="icon icon-notifications-full full"></span>
                  {{'header.notifications' | translate}}
                </a>
              </li>
              <li *ngIf="currentUserName">
                <a aria-label="workspace" title=" {{'header.workspace' | translate}}" [routerLink]="workspaceLink"
                  [routerLinkActive]="['active'] " class="title">
                  <span class="icon  icon-workspace-full full"></span>
                  {{'header.workspace' | translate}}
                </a>
              </li>
              <li *ngIf="currentUserName">
                <span class="icon lib-icon-logout"></span>
                <app-logout-button></app-logout-button>
              </li>
              <li *ngIf="!currentUserName">
                <app-login-button></app-login-button>
              </li>
            </ul>
          </div>
        </div>
      </ul>
    </ul>
  </div>
</nav>

<div class="desktop-header d-none d-lg-block" [ngClass]="{'dimmed-header' : IsDimmed , 'scrolled-header': isScrolled, 'white-bg': !isHomePage}">
  <div class="container">
    <nav class="header-wrapper" placement="right">
      <a routerLink="/" class="logo" aria-label="logo" title="{{'common.portalName' | translate}}"
        tooltip="{{'common.portalName' | translate}}" (click)="closeModal()">
        <img loading="lazy" width="148" height="62" [src]="logoSrc"
          alt="{{'common.portalName' | translate}}" />
      </a>
      <ul class="header-content">
        <!-- <li class="header-item header-search" [class.active]="isSearchOpen">
          <button class="search-btn header-btn" (click)="closeModal();openSearch()"
            tooltip="{{'header.search' | translate}}" placement="bottom">
            <span class="icon icon-search"></span>
          </button>
          <div class="general-search-bar">
            <input type="text" name="name" value="" class="search-input" placeholder="{{ 'header.search' | translate }}"
              tabindex="-1" />
            <a href="#" class="search-link header-btn" tabindex="-1">
              <span class="icon icon-search c-highlight-light"></span>
            </a>
          </div>
        </li> -->
        <li *ngIf="currentUserName" class="header-item header-workspace">
          <a [routerLink]="workspaceLink" title="{{'header.workspace' | translate}}" [routerLinkActive]="['active']"
            class="header-btn" tooltip="{{'header.workspace' | translate}}" placement="right" (click)="closeModal()">
            <span class="icon icon-workspace-full full"></span>
            <span class="icon icon-workspace-full "></span>
          </a>
        </li>
        <li *ngIf="currentUserName" class="header-item header-nots" dropdown [insideClick]="false"
          (click)="closeModal()">
          <app-notifications-announcement [IsDimmed]="IsDimmed" tooltip="{{'header.notifications' | translate}}"
            placement="right"></app-notifications-announcement>
        </li>
        <li *ngIf="hasLinkedOrTeams" class="header-item header-user-control " dropdown [insideClick]="true">
          <ng-container *ngIf="currentUserName || isLoading; else login">
            <button type="button" aria-label="close model" class="user-info on-behalf-btn" dropdownToggle
              tooltip="{{'header.account' | translate}}" placement="right" (click)="closeModal()">
              <ng-container *ngIf="!isRelatedProfileOpen">
                <div class="d-flex flex-column align-items-start " (click)="navigateToProfile()">
                  <span class="d-flex">
                    <span class="user-name text-truncate" title="{{mainAccount?.userDisplayName || userDisplayName}}">
                      {{mainAccount?.userDisplayName || userDisplayName}}
                    </span>
                    <span class="lib-icon-triangle text-danger mx-1"
                      popover="{{translation?.restrictedUser || 'Restricted User'}}" triggers="click"
                      [outsideClick]="true" *ngIf="mainAccount?.profileStatus == profileStatus.Restricted"
                      title="{{translation?.restrictedUser || 'Restricted User'}}">
                      <span class="path1"></span><span class="path2"></span><span class="path3"></span>
                    </span>
                    <span class="lib-icon-triangle text-danger mx-1"
                      popover="{{translation?.deactivatedUser || 'Deactivated User'}}" triggers="click"
                      [outsideClick]="true" *ngIf="mainAccount?.profileStatus == profileStatus.Deactivated"
                      title="{{translation?.deactivatedUser || 'Deactivated User'}}">
                      <span class="path1"></span><span class="path2"></span><span class="path3"></span>
                    </span>
                  </span>
                  <span class="d-flex">
                    <span class="onbehafeof-name text-truncate" title="{{onBehafeOf?.userDisplayName}}">
                      {{onBehafeOf?.userDisplayName}}
                    </span>
                    <span class="lib-icon-triangle  text-danger mx-1"
                      popover="{{translation?.restrictedUser || 'Restricted User'}}" triggers="click"
                      [outsideClick]="true" *ngIf="onBehafeOf?.profileStatus == profileStatus.Restricted"
                      title="{{translation?.restrictedUser || 'Restricted User'}}">
                      <span class="path1"></span><span class="path2"></span><span class="path3"></span>
                    </span>
                    <span class="lib-icon-triangle  text-danger mx-1"
                      popover="{{translation?.deactivatedUser || 'Deactivated User'}}" triggers="click"
                      [outsideClick]="true" *ngIf="onBehafeOf?.profileStatus == profileStatus.Deactivated"
                      title="{{translation?.deactivatedUser || 'Deactivated User'}}">
                      <span class="path1"></span><span class="path2"></span><span class="path3"></span>
                    </span>
                  </span>
                </div>
              </ng-container>
              <span class="lib-icon-down-head-arrow custom" (click)="openRelatedProfile()"
                [ngClass]="{'arrow-up': isRelatedProfileOpen, 'arrow-down': !isRelatedProfileOpen}"></span>
            </button>
            <div [class]="isMobile ? 'mobile-settings d-lg-none' : 'header-dropdown-menu settings-menu dropdown-menu'">
              <div [class]="isMobile ? 'settings-menu' : ''">
                <ul class="dropdown-list options-wrp">
                  <ng-container *ngIf="currentUserName && !isMobile">
                    <li class="dropdown-menu-item account">
                      <button (click)="navigateToProfile()" aria-label="navigate To Profile" class="text-right"> {{
                        "accessManagement.profileInfo" | translate }}</button>
                    </li>
                    <li class="dropdown-menu-item account">
                      <app-logout-button></app-logout-button>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
          </ng-container>
        </li>
        <li *ngIf="!hasLinkedOrTeams" class="header-item header-user-control " dropdown [insideClick]="true">
          <ng-container *ngIf="currentUserName || isLoading; else login">
            <button  aria-label="user-info"   type="button" class="user-info" dropdownToggle tooltip="{{'header.account' | translate}}"
              placement="right" (click)="closeModal()">
              <span class="user-name text-truncate">{{userSummaryData?.userDisplayName || userDisplayName}}</span>
              <i class="icon icon-arrow-down arrow-down"></i>
              <span class="lib-icon-triangle text-danger mx-1"
                popover="{{translation?.restrictedUser || 'Restricted User'}}" triggers="click" [outsideClick]="true"
                *ngIf="userSummaryData?.profileStatus == profileStatus.Restricted"
                title="{{translation?.restrictedUser || 'Restricted User'}}">
                <span class="path1"></span><span class="path2"></span><span class="path3"></span>
              </span>
              <span class="lib-icon-triangle text-danger mx-1"
                popover="{{translation?.deactivatedUser || 'Deactivated User'}}" triggers="click" [outsideClick]="true"
                *ngIf="userSummaryData?.profileStatus == profileStatus.Deactivated"
                title="{{translation?.deactivatedUser || 'Deactivated User'}}">
                <span class="path1"></span><span class="path2"></span><span class="path3"></span>
              </span>
            </button>
            <div [class]="isMobile ? 'mobile-settings d-lg-none' : 'header-dropdown-menu settings-menu dropdown-menu'">
              <div [class]="isMobile ? 'settings-menu' : ''">
                <ul class="dropdown-list options-wrp">
                  <ng-container *ngIf="currentUserName && !isMobile">
                    <li class="dropdown-menu-item account">
                      <button class="text-right" aria-label="navigate To Profile" (click)="navigateToProfile()"> {{ "accessManagement.profileInfo" |
                        translate }}</button>
                    </li>
                    <li class="dropdown-menu-item account">
                      <app-logout-button></app-logout-button>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
          </ng-container>
        </li>
        <li class="header-item header-user-control" dropdown [insideClick]="true">
          <button  aria-label="on Language Switched"  class="language-switcher-btn header-btn d-flex justify-content-center gap-1 align-items-center "
            (click)="onLanguageSwitched($event)" aria-label="lang" name="lang"
            title="{{'header.languages' | translate}}" tooltip="{{'header.languages' | translate}}">
            <span>{{'languageSwitcher.'+ switchToLang| translate}}</span>
            <span *ngIf="this.GetCurrentLanguage() == 'ar'">
              <img loading="lazy" width="15" height="15" src="../../assets/images/En.svg" alt="{{'common.switshEnglish' | translate}}">
            </span>
            <span *ngIf="this.GetCurrentLanguage() == 'en'">
              <img width="15" height="15" loading="lazy" src="../../assets/images/AR.svg" alt="{{'common.switshArabic' | translate}}">
            </span>
          </button>
        </li>

        <li class="header-item header-user-control " dropdown [insideClick]="true">
          <button   aria-label="close Modal"   type="button" class="theme-switcher-btn" dropdownToggle tooltip="{{'header.settings' | translate}}"
            placement="right" (click)="closeModal()">
            <i class="icon icon-fi-rr-opacity setting-icon"></i>
            <i class="icon icon-arrow-down arrow-down"></i>

          </button>
          <app-theme-switcher></app-theme-switcher>
        </li>

      </ul>
    </nav>
  </div>
</div>

<ng-template #login>
  <app-login-button></app-login-button>
</ng-template>


<ng-container *ngIf="hasLinkedOrTeams && isRelatedProfileOpen">
  <div class="overlay  d-none d-lg-block" [ngClass]="{'is-open': isRelatedProfileOpen}">
    <!-- <div class="my-modal"> -->
    <div class="user-controler-modal-content">
      <div class="conatiner  user-control-container ">
        <div class="row">
          <div class="col-9 account-table" *ngIf="profilesDataSource.length > 0">
            <app-related-profile-table #relatedProfilesTable [selectedItems]="onBehafeOf? [onBehafeOf] : []"
              (onBehafeOfSelected)="selectProfile($event)" [tableHeader]="tableHeader"
              [tableContent]="profilesDataSource" [totalRecords]="profilesDataSource.length" [keyField]="keyField"
              gridTitle="{{'accessManagement.onBehalfOf' | translate}}" (onRowClicked)="onRowClicked($event)">
            </app-related-profile-table>


            <button type="button"  aria-label="close Modal" class="btn-link mx-auto close-custom rounded"
              (click)="closeModal()">{{'accessManagement.close' | translate}}</button>
          </div>
          <div class="col-9 " *ngIf="profilesDataSource.length  == 0">
          </div>
          <div class="col-3 account-tabs" [ngClass]="{'rounded': profilesDataSource.length  == 0}">
            <div class="row">
              <app-related-profile-tabs [currentProfile]="currentProfile" [currentIndex]="currentIndex"
                class="d-block w-100" (onViewAccount)="onViewAccount($event)" (onSetDefault)="onSetDefault($event)"
                [teamsOwners]="userSummaryData.teamsOwners" [selectedItems]="onBehafeOf? [onBehafeOf] : []"
                (onSelectAccount)="onSelectAccount($event)" [keyField]="keyField"></app-related-profile-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</ng-container>
<!-- </ng-template> -->